export function ArrowComponent(props: Readonly<React.SVGProps<SVGSVGElement>>) {
    return (
        <svg
            width={220}
            height={16}
            viewBox="0 0 190 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M189.707 8.707a1 1 0 000-1.414L183.343.929a1 1 0 10-1.414 1.414L187.586 8l-5.657 5.657a1 1 0 101.414 1.414l6.364-6.364zM0 9h189V7H0v2z"
                fill="#000"
            />
        </svg>
    )
}
